import React from "react";
import { faCalendarDays } from "@fortawesome/pro-light-svg-icons";
import { Spinner } from "@hdir/ui/spinner";
import FontAwesomeIconWrapper from "../FontAwesomeIconWrapper/FontAwesomeIconWrapper";
import CardLoading from "../Cards/Loading/Loading";
import ListSearchResultCardSelector from "./ListSearchResultCardSelector";

import type { ListSearchResultContainerProps } from "../../../site/parts/listSearch/type.d";

export default function ListSearchResultContainer(props: Readonly<ListSearchResultContainerProps>) {
  const {
    cardBaseId,
    isInitialPageLoad,
    isFetching,
    list,
    localizedForListSearch,
    paginationSize
  } = props;

  let prevGroupByValue = "";

  if (isInitialPageLoad) {
    return (
      Array.from({ length: paginationSize || 5 }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <CardLoading key={index} />))
    );
  }

  if (isFetching) {
    return (
      <Spinner className="pt-lg" style={{ paddingBottom: `${paginationSize * 160}px` }} size="large" />
    );
  }

  if (!list?.length) {
    return <p className="mt-lg">{localizedForListSearch.noResults}</p>;
  }

  return (
    <div className="mt-lg">
      {list.map((item, index) => {
        const key = item?.id || index;
        const wrapper = (
          <div
            key={key}
            data-item-id={`${cardBaseId}-${index}`}
            tabIndex={-1}
            className="result-item-wrapper my-md"
          >
            <ListSearchResultCardSelector
              {...item}
              localizedForListSearch={localizedForListSearch}
              groupBy={item.groupBy?.value}
            />
          </div>
        );

        if (item.groupBy?.value) {
          const showGroupBy = item.groupBy.value !== prevGroupByValue;
          prevGroupByValue = item.groupBy.value;
          return (
            <React.Fragment key={`group-${key}`}>
              {showGroupBy && (
                <div className="mt-xl">
                  <div className="flex flex-row items-center">
                    {item.groupBy.isDate && (
                      <FontAwesomeIconWrapper
                        className="mr-xs text-icon-action"
                        icon={faCalendarDays}
                      />
                    )}
                    <h2>{item.groupBy.value}</h2>
                  </div>
                  <div className="w-full h-px bg-surface-action-primary-disabled mb-md" />
                </div>
              )}
              {wrapper}
            </React.Fragment>
          );
        }

        return wrapper;
      })}
    </div>
  );
}
